import React, { forwardRef } from 'react';

export default forwardRef(function Button(
  {
    type = 'button',
    children,
    onClick,
    classes = '',
    theme = 'base',
    testId = 'button',
    disabled = false,
    id = '',
  },
  ref
) {
  let colors;
  switch (theme) {
    case 'base':
      colors = 'bg-button text-white hover:bg-stone-800';
      break;
    case 'outline':
      colors =
        'border border-button text-button hover:bg-button hover:text-white';
      break;
    case 'dark':
      colors = 'bg-black text-white hover:bg-black';
      break;
    default:
      colors = 'bg-button text-white hover:bg-stone-800';
  }
  return (
    <button
      ref={ref}
      data-testid={testId}
      id={id}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`rounded-lg py-3 px-4 uppercase transition duration-300 ${colors} ${classes} ${
        disabled ? 'pointer-events-none bg-stone-500' : ''
      }`}
    >
      {children}
    </button>
  );
});
